import { useEffect, useState } from "react";
import { getMyMonthStats } from "../services/drinkService";
import MonthChart from "./MonthChart";
import DayDetailModal from "./DayDetailModal";

const MOIS_NOMS = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

export default function MyStatsModal({ onClose }) {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedDay, setSelectedDay] = useState(null);

  const isCurrentMonth = year === now.getFullYear() && month === now.getMonth() + 1;

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    getMyMonthStats(year, month)
      .then((data) => { if (active) setStats(data); })
      .catch(() => { if (active) setError("Impossible de charger tes stats"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [year, month]);

  const goPrevMonth = () => {
    if (month === 1) { setMonth(12); setYear((y) => y - 1); }
    else setMonth((m) => m - 1);
  };

  const goNextMonth = () => {
    if (isCurrentMonth) return;
    if (month === 12) { setMonth(1); setYear((y) => y + 1); }
    else setMonth((m) => m + 1);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="card modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="btn-ghost modal-close" onClick={onClose}>Fermer ✕</button>

        <h3>Ta consommation</h3>

        <div className="month-nav">
          <button className="btn-secondary" onClick={goPrevMonth}>←</button>
          <span className="month-nav-label">{MOIS_NOMS[month - 1]} {year}</span>
          <button className="btn-secondary" onClick={goNextMonth} disabled={isCurrentMonth}>→</button>
        </div>

        {loading && <p className="muted">Chargement...</p>}
        {error && <p className="error">{error}</p>}

        {stats && !loading && (
          <>
            <p className="muted">
              {stats.total_mois} verre{stats.total_mois > 1 ? "s" : ""} ce mois-ci
            </p>

            <MonthChart
              data={stats.par_jour}
              year={year}
              month={month}
              onDayClick={setSelectedDay}
            />

            <h4>Répartition du mois</h4>
            {stats.repartition.length === 0 ? (
              <p className="muted">Rien enregistré ce mois-ci.</p>
            ) : (
              <ul className="bar-list">
                {stats.repartition.map((r) => (
                  <li key={r.nom}>
                    <div className="bar-row"><span>{r.nom}</span><span>{r.nb}</span></div>
                    <div className="bar-track">
                      <div className="bar-fill" style={{ width: `${(r.nb / stats.repartition[0].nb) * 100}%` }} />
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>

      {selectedDay && (
        <DayDetailModal
          date={`${year}-${String(month).padStart(2, "0")}-${String(selectedDay).padStart(2, "0")}`}
          onClose={() => setSelectedDay(null)}
        />
      )}
    </div>
  );
}